<template>
  <div class="section row mt-4 mb-5">
    <div class="row">
      <div class="col-12 pb-1 pt-2 border-bottom">
        <h5 class="h5-sor">下载客户端 <small class="text-muted">畅享便捷体验，全平台通用无阻</small></h5>
      </div>
    </div>
    <div class="col-6 pr-0">
      <a @click="goDownLoad('Ios')" class="btn btn-light btn-block mt-2 d-flex justify-content-center pt-2 pb-2">
        <i class="fa fa-apple fa-3x align-self-center"></i>
        <div class="flex-column text-left pl-1 align-self-center">
          苹果 IOS <br> <small class="">支持国区Appstore</small>
        </div>
      </a>
    </div>
    <div class="col-6">
      <a @click="goDownLoad('Android')" class="btn btn-light btn-block mt-2 d-flex justify-content-center pt-2 pb-2">
        <i class="fa fa-android fa-3x align-self-center"></i>
        <div class="flex-column text-left pl-1 align-self-center">
          Android 安卓 <br> <small>手机 / 平板</small>
        </div>
      </a>
    </div>
    <div class="col-6 mt-2 pr-0">
      <a @click="goDownLoad('Windows')" class="btn btn-light btn-block mt-2 d-flex justify-content-center pt-2 pb-2">
        <i class="fa fa-windows fa-3x align-self-center"></i>
        <div class="flex-column text-left pl-1 align-self-center">
          Windows&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <br> <small>Win10 / 7</small>
        </div>
      </a>
    </div>
    <div class="col-6 mt-2">
      <a @click="goDownLoad('MacOs')" class="btn btn-light btn-block mt-2 d-flex justify-content-center pt-2 pb-2">
        <i class="fa fa-apple fa-3x align-self-center"></i>
        <div class="flex-column text-left pl-1 align-self-center">
          MacOS
          <br> <small>10.15 Catalina</small>
        </div>
      </a>
    </div>
    <div class="col-6 mt-2">
      <a @click="goDownLoad('Linux')" class="btn btn-light btn-block mt-2 d-flex justify-content-center pt-2 pb-2">
        <i class="fa fa-linux fa-3x align-self-center"></i>
        <div class="flex-column text-left pl-1 align-self-center">
          Linux
          <br> <small>Debian/Ubuntu</small>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "downLoadApp",
  methods:{
    goDownLoad(name){
      this.$router.push({
        name:'tutorials',
        params:{
          name:name,
        }
      })
    }
  }
}
</script>

<style scoped>
.section {
  padding: 15px;
}
@media (min-width: 768px) {
  .h5-sor {
    font-size: 2rem;
  }
}

@media (min-width: 437px) and (max-width: 767px) {
  .sTitle ~ div {
    font-size: 16px;
  }

  .h5-sor {
    font-size: 1.5rem;
  }
}

@media (max-width: 436px) {
  .sTitle ~ div {
    font-size: 12px;
  }

  .h5-sor {
    font-size: 1.1rem;
  }
}
</style>